import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Quote } from './initialState';

interface QuoteState {
  quotes: Quote[];
  selectedQuoteId: string | null;
}

const initialState: QuoteState = {
  quotes: [],
  selectedQuoteId: null,
};

const quotesSlice = createSlice({
  name: 'quotes',
  initialState,
  reducers: {
    setQuotes(state, action: PayloadAction<Quote[]>) {
      state.quotes = action.payload;
    },
    setSelectedQuote(state, action: PayloadAction<string | null>) {
      state.selectedQuoteId = action.payload;
    },
    clearQoutes(state) {
      state.quotes = [];
      state.selectedQuoteId = null;
    },
  },
});

export const { setSelectedQuote, setQuotes, clearQoutes } = quotesSlice.actions;
export default quotesSlice.reducer;
